import VueCqrs from '@cqrs/vue-component-cqrs';
import * as q from '@Evaluation/Estimations/Domain/queries';
import Component from 'vue-class-component';

@Component
export default class EstimationsQueries extends VueCqrs
{
	runPanelsPageQueryV1(projectId: number)
	{
		const query = q.buildPanelsPageQueryV1(projectId);
		this.$query(query);
	}

	runPanelistsPageQueryV1(surveyId: number)
	{
		const query = q.buildPanelistsPageQueryV1(surveyId);
		this.$query(query);
	}

	runMeetingManagerPageQueryV1(surveyId: number)
	{
		const query = q.buildMeetingManagerPageQueryV1(surveyId);
		this.$query(query);
	}

	runPanelistDashboardPageQueryV1(workspaceId: number, surveyId: number, projectUserId: number)
	{
		const query = q.buildPanelistDashboardPageQueryV1(workspaceId, surveyId, projectUserId);
		this.$query(query);
	}

	runPanelistAlternativePageQueryV1(workspaceId: number, surveyId: number, projectUserId: number, alternativeId: number)
	{
		const query = q.buildPanelistAlternativePageQueryV1(workspaceId, surveyId, projectUserId, alternativeId);
		this.$query(query);
	}

	runPanelistMeetingPageQueryV1(workspaceId: number, surveyId: number, projectUserId: number)
	{
		const query = q.buildPanelistMeetingPageQueryV1(workspaceId, surveyId, projectUserId);
		this.$query(query);
	}


	runExportAllVotesQueryV1(workspaceId: number, projectId: number, evalModelId: number)
	{
		const query = q.buildExportAllVotesQueryV1(workspaceId, projectId, evalModelId);
		this.$query(query);
	}

	runExportAllDisagreementsQueryV1(workspaceId: number, projectId: number, evalModelId: number)
	{
		const query = q.buildExportAllDisagreementsQueryV1(workspaceId, projectId, evalModelId);
		this.$query(query);
	}

	runExportAccessLinksBySurveyIdQueryV1(workspaceId: number, surveyId: number)
	{
		const query = q.buildExportAccessLinksBySurveyIdQueryV1(workspaceId, surveyId);
		this.$query(query);
	}

	runExportPanelistVotesQueryV1(workspaceId: number, surveyId: number, projectUserId: number)
	{
		const query = q.buildExportPanelistVotesQueryV1(workspaceId, surveyId, projectUserId);
		this.$query(query);
	}



	runPanelQueryV1(workspaceId: number, surveyId: number)
	{
		const query = q.buildPanelQueryV1(workspaceId, surveyId);
		this.$query(query);
	}

	runPanelByNameQueryV1(workspaceId: number, evalModelId: number, name: string)
	{
		const query = q.buildPanelByNameQueryV1(workspaceId, evalModelId, name);
		this.$query(query);
	}

	runPanelistsQueryV1(workspaceId: number, surveyId: number)
	{
		const query = q.buildPanelistsQueryV1(workspaceId, surveyId);
		this.$query(query);
	}

	runPanelistQueryV1(workspaceId: number, surveyId: number, projectUserId: number)
	{
		const query = q.buildPanelistQueryV1(workspaceId, surveyId, projectUserId);
		this.$query(query);
	}

	runHostActiveQuestionQueryV1(workspaceId: number, surveyId: number, questionId: string)
	{
		const query = q.buildHostActiveQuestionQueryV1(workspaceId, surveyId, questionId);
		this.$query(query);
	}

	runPanelistVoteQueryV1(workspaceId: number, projectUserId: number, questionId: string)
	{
		const query = q.buildPanelistVoteQueryV1(workspaceId, projectUserId, questionId);
		this.$query(query);
	}

	runDisagreementsQueryV1(workspaceId: number, surveyId: number)
	{
		const query = q.buildDisagreementsQueryV1(workspaceId, surveyId);
		this.$query(query);
	}
}